import { IconType } from "react-icons";
import { IoSearchOutline } from "react-icons/io5";
import { LuBookOpen } from "react-icons/lu";
import { RiPencilRuler2Line } from "react-icons/ri";
import Image from "next/image";
import { LogoPila } from "../assets";

export type SidebarLabel =
	| "คลังบทเรียนต้นแบบ"
	| "คลังบทเรียนของคุณ"
	| "สร้างแบบฝึกหัดใหม่"

type MenuItem = {
	label: SidebarLabel;
	icon: IconType;
	disabled?: boolean;
};

const menuItems: MenuItem[] = [
	{ label: "คลังบทเรียนต้นแบบ", icon: IoSearchOutline },
	{ label: "คลังบทเรียนของคุณ", icon: LuBookOpen },
	{ label: "สร้างแบบฝึกหัดใหม่", icon: RiPencilRuler2Line },
];

type SidebarProps = {
	selectedLabel: SidebarLabel;
	onSelect: (label: SidebarLabel) => void;
};

export default function Sidebar({ selectedLabel, onSelect }: SidebarProps) {
	return (
		<aside className="w-60 shrink-0 bg-[#ffffff] p-5">
			<nav className="space-y-3">
				{menuItems.map((item) => {
					const Icon = item.icon;
					const isDisabled = Boolean(item.disabled);
					const isActive = selectedLabel === item.label;

					return (
						<button
							key={item.label}
							type="button"
							disabled={isDisabled}
							onClick={() => onSelect(item.label)}
							className={`flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left  text-base transition ${isActive
									? "text-sky-600 cursor-pointer"
									: isDisabled
										? "cursor-not-allowed "
										: "text-[#808080] hover:bg-neutral-200 cursor-pointer"
								}`}
						>
							<Icon className="text-[20px]" />
							<span className="text-base font-normal">{item.label}</span>
						</button>
					);
				})}
			</nav>
			<a
				href="https://thailand.pilaproject.org/teacher/classes"
				className="mb-3 mt-4 flex w-full items-center gap-3 rounded-lg px-2 py-3 transition hover:bg-neutral-200"
			>
				<Image
					src={LogoPila}
					alt="Pila Workspace"
					width={26}
					height={26}
					className="h-6.5 w-6.5 rounded-md"
				/>
				<span className="text-md font-semibold leading-none text-neutral-700">
					Pila Workspace
				</span>
			</a>
		</aside>
	);
}
